import React from "react"

const TickIcon = ({ fill }) => (<svg id="check" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 25 25">
  <path id="Path_19796" data-name="Path 19796" d="M12.5,0A12.5,12.5,0,1,1,0,12.5H0A12.464,12.464,0,0,1,12.429,0Z" transform="translate(0 0)" fill={fill} />
  <path id="Path_19797" data-name="Path 19797" d="M95.874,105.957,87,114.834,82.025,109.9l2.024-1.989L87,110.822l6.854-6.854Z" transform="translate(-76.449 -96.901)" fill="#FFFFFF" />
</svg>)


export default TickIcon
